export default (activeCell, row, column) => (!!activeCell &&
    activeCell.row === row &&
    activeCell.column === column);
